import { useState, useRef, useEffect } from 'react';
import { HelpCircle, X } from 'lucide-react';

export function HelpTooltip({ text, testId }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open]);

  return (
    <div className="relative inline-flex" ref={ref}>
      <button
        onClick={() => setOpen(!open)}
        className="w-6 h-6 rounded-full flex items-center justify-center transition-colors hover:bg-gray-100"
        style={{ color: 'var(--ink-muted)' }}
        data-testid={testId || 'help-tooltip'}
        aria-label="Help"
      >
        <HelpCircle className="w-4 h-4" strokeWidth={1.75} />
      </button>
      {open && (
        <div className="absolute top-full right-0 mt-1.5 z-50 w-64 p-3 rounded-xl border bg-white shadow-lg animate-in fade-in-0 zoom-in-95"
          style={{ borderColor: 'var(--border-color)' }}>
          <div className="flex items-start gap-2">
            <p className="text-xs leading-relaxed flex-1" style={{ color: 'var(--navy-ink)' }}>{text}</p>
            <button onClick={() => setOpen(false)} className="flex-shrink-0 mt-0.5">
              <X className="w-3 h-3" style={{ color: 'var(--ink-muted)' }} />
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default HelpTooltip;
